import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'


const initialState = Immutable.Map({})
  .set('listDonatarias', new Immutable.List([]))
  .set('listCorrida', new Immutable.List([]))
  .set('listIndicadores', new Immutable.List([]))

/* Types */
export const ACTION_GET_DONATIONS = "ACTION_GET_DONATIONS"
export const ACTION_GET_INDICADORES = "ACTION_GET_INDICADORES"
export const ACTION_GET_CORRIDA_5 = "ACTION_GET_CORRIDA_5"


/* Reducer */
export default (state = initialState, action) => {

  switch (action.type) {
    case ACTION_GET_DONATIONS:
      return state.set('listDonatarias', new Immutable.List(action.Obj))
    case ACTION_GET_INDICADORES:
      return state.set('listIndicadores', new Immutable.List(action.Obj))
    case ACTION_GET_CORRIDA_5:
      return state.set('listCorrida', new Immutable.List(action.Obj))
    default:
      return state
  }

}

export const getDonatariaIndicador = (form) => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getDonatariaIndicador',
      method: 'POST',
      data: {...form},
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))


      dispatch({
        type: ACTION_GET_DONATIONS,
        Obj: response.data
      })
    }).catch(error => {
      dispatch(isLoading(false))

      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

/* Action Creators */
export const getDonation = (form) => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getDonationCorridas',
      method: 'POST',
      data: {...form},
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))


      dispatch({
        type: ACTION_GET_DONATIONS,
        Obj: response.data
      })
    }).catch(error => {
      dispatch(isLoading(false))

      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}


export const getIndicadores = (form) => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getIndicadorCorridas',
      method: 'POST',
      data: {...form},
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))

      dispatch({
        type: ACTION_GET_INDICADORES,
        Obj: response.data
      })
    }).catch(error => {
      dispatch(isLoading(false))

      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}


export const getCorrida5Anios = (form) => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getCorrida5Anios',
      method: 'POST',
      data: {...form},
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))

      dispatch({
        type: ACTION_GET_CORRIDA_5,
        Obj: response.data
      })
    }).catch(error => {
      dispatch(isLoading(false))

      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const clearIndicadores = (form) => {

  return (dispatch) => {
      dispatch({
        type: ACTION_GET_INDICADORES,
        Obj: new Immutable.List(Utils.createTableDonatarias([]))
      })

  }
}


export const insertDonatarias = (form) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_GET_DONATIONS,
      Obj: new Immutable.List(Utils.createTableDonatarias(form))
    })

  }
}


export const clearDonatios = (form) => {

  return (dispatch) => {
    dispatch({
      type: ACTION_GET_DONATIONS,
      Obj:  new Immutable.List(Utils.createTableDonatarias([]))
    })

  }
}






// WEBPACK FOOTER //
// ./src/modules/Donations/Donations.js